import { render, staticRenderFns } from "./crew-advrequest.vue?vue&type=template&id=d82028f6"
import script from "./crew-advrequest.vue?vue&type=script&lang=js"
export * from "./crew-advrequest.vue?vue&type=script&lang=js"
import style0 from "./crew-advrequest.vue?vue&type=style&index=0&id=d82028f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports